/**
 * web/src/hooks/queries/useWorkflow.ts
 * Single workflow detail (steps + paginated audit + tracked emails).
 * Cache key prefix `['workflow', id]` matches the WS handler's narrowed
 * detail-page invalidate (D-2.1).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchWorkflow } from '../../api/workflows';
import { qk } from '../../lib/queryKeys';

/**
 * Fetches GET /api/workflows/:id with cursor-paginated audit log.
 *
 * @param id workflow id; query disabled while undefined
 * @param cursor opaque audit-log cursor from a prior page (optional)
 * @param limit page size (default 50, server max 200)
 * @returns React Query result for WorkflowDetail
 * @sideEffects HTTP GET
 * @idempotent yes
 */
export function useWorkflow(id: string | undefined, cursor?: string, limit = 50) {
  return useQuery({
    queryKey: qk.workflow.detail(id, cursor, limit),
    queryFn: () => fetchWorkflow(id!, cursor, limit),
    enabled: id != null,
  });
}
